<template>
    <div class="wrapper">
        <NavBar />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="container-fluid py-2" style="background-color: white !important;">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-12 text-center wow fadeInDown">
                            <img :src="folder" alt="User Profil" class="img-size-50 mr-3 img-circle shake-element"
                                style="height: 80px !important;width: 80px !important;"><br><br>
                            <h5>Halo {{ sapaan }}, <span class="text-success">{{ namauser }}</span>, {{
                                jabatanuser }}
                            </h5>
                            <div class="row">
                                <div class="col-sm-2 text-center"></div>
                                <div class="col-sm-8 text-center">
                                    <div class="card" style="background-color: rgba(255, 255, 255, 0.1)">
                                        <div class="row py-2 px-2">
                                            <div class="col-sm-12 text-center" style="padding-bottom: 5px;">
                                                {{ hasil }} {{ hariAngka }}
                                            </div>
                                            <div class="col-sm-12 text-center" style="padding-bottom: 5px;">
                                                <div class="row py-2 px-2">
                                                    <div class="col-sm-12 text-center bgbiru">
                                                        <h2 class="text-white">Profil Pengguna</h2>
                                                    </div>
                                                    <div class="col-sm-12 text-center">&nbsp;</div>
                                                    <div class="col-sm-12 text-center">
                                                        Nama: {{ namauser }}
                                                    </div>
                                                    <div class="col-sm-12 text-center">
                                                        Jabatan: {{ jabatanuser }}
                                                    </div>
                                                    <div class="col-sm-12 text-center">&nbsp;</div>
                                                    <div class="col-sm-12 text-left">
                                                        <label>Password Lama<small class="text-info"> (*wajib
                                                                diisi)</small></label>
                                                        <div class="input-group mb-3">
                                                            <input :type="[showPassword ? 'text' : 'password']"
                                                                class="form-control form-control-sm" id="password_lama"
                                                                name="password_lama" placeholder="Password Lama User"
                                                                v-model="password_lama">
                                                            <div class="input-group-append">
                                                                <button type="button" class="btn" @click="toggleShow">
                                                                    <i
                                                                        :class="{ 'fas fa-eye-slash text-muted': showPassword, 'fas fa-eye text-muted': !showPassword }"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 text-left">
                                                        <label>Password Baru<small class="text-info"> (*wajib
                                                                diisi)</small></label>
                                                        <div class="input-group mb-3">
                                                            <input :type="[showPasswordBaru ? 'text' : 'password']"
                                                                class="form-control form-control-sm" id="password_baru"
                                                                name="password_baru" placeholder="Password Baru User"
                                                                v-model="password_baru" @keyup="cekkekuatan()">
                                                            <div class="input-group-append">
                                                                <button type="button" class="btn"
                                                                    @click="toggleShowBaru">
                                                                    <i
                                                                        :class="{ 'fas fa-eye-slash text-muted': showPasswordBaru, 'fas fa-eye text-muted': !showPasswordBaru }"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <label>Kekuatan kata sandi<small class="text-info"> (*minimal
                                                                skor 60%)</small></label>
                                                        <div class="progress">
                                                            <div class="progress-bar" role="progressbar"
                                                                aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"
                                                                style="width:0%" id="persennyapassworddata">
                                                                <span id="tulisanpersennyapassworddata">0%</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        &nbsp;
                                                    </div>
                                                    <div class="col-sm-12">
                                                        &nbsp;
                                                    </div>
                                                    <div class="col-sm-12 text-left">
                                                        <label>Konfirmasi Password Baru<small class="text-info"> (*wajib
                                                                diisi)</small></label>
                                                        <div class="input-group mb-3">
                                                            <input
                                                                :type="[showPasswordKonfirmasi ? 'text' : 'password']"
                                                                class="form-control form-control-sm" id="password_baru2"
                                                                name="password_baru2"
                                                                placeholder="Konfirmasi Password Baru"
                                                                v-model="password_baru2">
                                                            <div class="input-group-append">
                                                                <button type="button" class="btn"
                                                                    @click="toggleShowKonfirmasi">
                                                                    <i
                                                                        :class="{ 'fas fa-eye-slash text-muted': showPasswordKonfirmasi, 'fas fa-eye text-muted': !showPasswordKonfirmasi }"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-4 text-center"></div>
                                                    <div class="col-sm-4 text-center">
                                                        <button type="button" :disabled="strengthdata < 60"
                                                            class="btn btn-primary btn-sm text-white lebar2"
                                                            @click="prosesdata()" data-toggle="tooltip"
                                                            data-placement="left" title="Simpan Perubahan..">
                                                            <i class="fas fa-edit"></i> Simpan Perubahan
                                                        </button>
                                                    </div>
                                                    <div class="col-sm-4 text-center"></div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-2 text-center"></div>
                            </div>
                        </div><!-- /.col -->
                        <div class="col-sm-12 text-center">&nbsp;</div>
                        <div class="col-sm-12 text-center">&nbsp;</div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import Footer from "../componen/FooterAksi.vue";
import NavBar from "../componen/NavBarAksi.vue";
import Menu from "../componen/Menu.vue";
import swal from 'sweetalert2';
import VueApexCharts from "vue3-apexcharts";
import { quillEditor } from 'vue3-quill';
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };

export default {
    components: {
        Footer, NavBar, Menu, vSelect, apexchart: VueApexCharts, quillEditor, swal,
    },
    data() {
        return {
            halamanloading: true,
            showFilter: true,
            iduser: JSON.parse(localStorage.getItem("isistemaksi")),
            leveluser: JSON.parse(localStorage.getItem("lsistemaksi")),
            namauser: JSON.parse(localStorage.getItem("namasistemaksi")),
            jabatanuser: JSON.parse(localStorage.getItem("jabatansistemaksi")),
            tokensistemaksi: JSON.parse(localStorage.getItem("tokensistemaksi")),
            datapesan: '',
            sapaan: '',
            datamaster: [],
            carikata: '',
            datatahun: [],
            tahun: [],
            defaultSelectedtahun: {},
            selectedtahun: new Date().getFullYear(),
            jam: '',
            menit: '',
            detik: '',
            hasil: '',
            hariAngka: '',
            statusjam: '',
            timer: null,
            folder: process.env.VUE_APP_URL_API + 'androidAbsensi-Gambar?f=' + JSON.parse(localStorage.getItem("ikonsistemaksi")),
            latitude: '',
            longitude: '',
            project_id: process.env.VUE_APP_PROJECT_ID,
            jam_masuk: '',
            jam_pulang: '',
            tanggal_masuk: '',
            tanggal_pulang: '',
            tipe: '',
            id: '',
            ket: '',
            class: '',
            proses: '',
            durasi: '',
            jamdurasi: 0,
            menitdurasi: 0,
            detikdurasi: 0,
            linknya: process.env.VUE_APP_URL_API,
            dari_tanggal: '',
            sampai_tanggal: '',
            status: [],
            datastatus: [],
            defaultSelectedstatus: {
                code: 0,
                label: 'Pilih Lokasi',
                tag: '',
            },
            selectedstatus: '',
            keterangan: '',
            validasi: false,
            showPassword: false,
            showPasswordBaru: false,
            showPasswordKonfirmasi: false,
            password_baru: '',
            password_baru2: '',
            password_lama: '',
            strengthdata: 0,
        }
    },
    methods: {
        validasidata() {
            if ((this.password_lama == '')) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan Password Lama..',
                });
                return false;
            }
            if ((this.password_baru == '')) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan Password Baru..',
                });
                return false;
            }
            if ((this.password_baru2 == '')) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan Konfirmasi Password Baru..',
                });
                return false;
            }
            if ((this.password_baru != this.password_baru2)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Password Baru dan konfirmasinya tidak sama..',
                });
                return false;
            }
            this.validasi = true;
            return;
        },
        cekkekuatan() {
            //alert(this.passworddata);
            this.strengthdata = 0;
            var lowerCase = this.password_baru.match(/[a-z]/);
            var upperCase = this.password_baru.match(/[A-Z]/);
            var numbers = this.password_baru.match(/[0-9]/);
            var width = this.password_baru.length;
            var specialCharacters = this.password_baru.match(/[\!\~\@\&\#\$\%\^\&\*\(\)\{\}\?\-\_\+\=]/);
            if (width > 8) {
                this.strengthdata = this.strengthdata + 20;
            }
            if (lowerCase) {
                this.strengthdata = this.strengthdata + 20;
            }
            if (upperCase) {
                this.strengthdata = this.strengthdata + 20;
            }
            if (numbers) {
                this.strengthdata = this.strengthdata + 20;
            }
            if (specialCharacters) {
                this.strengthdata = this.strengthdata + 20;
            }
            document.getElementById('persennyapassworddata').style.width = this.strengthdata + "%";
            document.getElementById('tulisanpersennyapassworddata').innerHTML = this.strengthdata + "%";
        },
        toggleShow() {
            this.showPassword = !this.showPassword;
        },
        toggleShowBaru() {
            this.showPasswordBaru = !this.showPasswordBaru;
        },
        toggleShowKonfirmasi() {
            this.showPasswordKonfirmasi = !this.showPasswordKonfirmasi;
        },
        prosesdata() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            swal.fire({
                title: "Konfirmasi",
                text: "Data sudah benar?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Belum",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Sudah"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.halamanloading = true;
                    var fd = new FormData();
                    fd.append("id", this.iduser);
                    fd.append("password_lama", this.password_lama);
                    fd.append("password_baru", this.password_baru);
                    fd.append("project_id", this.project_id);

                    const mainAPI = axios.create({
                        baseURL: process.env.VUE_APP_URL_API,
                        headers: {
                            "Content-Type": "form-data",
                            Authorization: "Bearer " + localStorage.getItem("tokensistemaksi"),
                        },
                    });
                    mainAPI.post("androidAbsensi-UpdatePassword", fd).then(
                        Response => {
                            if (Response.data.response == 'error') {
                                swal.fire('Peringatan', Response.data.message, 'error');
                            }
                            else {
                                swal.fire('Informasi', 'Data perubahan berhasil', 'success').then(function () {
                                    localStorage.removeItem('tokensistemaksi');
                                    localStorage.removeItem('isistemaksi');
                                    localStorage.removeItem('lsistemaksi');
                                    localStorage.removeItem('project_idaksi');
                                    localStorage.removeItem('namasistemaksi');
                                    localStorage.removeItem('jabatansistemaksi');
                                    localStorage.removeItem('ikonsistemaksi');
                                    localStorage.removeItem('jenis_piusistemaksi');
                                    localStorage.removeItem('tsistem');
                                    window.location.replace("/AksiLogin");
                                });
                                $('.swal2-container').css("z-index", '999999');
                            }
                        }
                    ).catch(function (error) {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: error
                        });
                    }
                    )
                }
            });
        },
        LihatWaktu() {
            this.timer = setInterval(() => {
                var jam = new Date().getHours();
                if (jam < 12) {
                    this.sapaan = "Selamat Pagi";
                } else if (jam < 15) {
                    this.sapaan = "Selamat Siang";
                } else if (jam < 19) {
                    this.sapaan = "Selamat Sore";
                } else {
                    this.sapaan = "Selamat Malam";
                }

                var now = new Date();

                this.jam = now.getHours();
                this.menit = now.getMinutes();
                this.detik = now.getSeconds();
                this.jam = (this.jam < 10) ? "0" + this.jam : this.jam;
                this.menit = (this.menit < 10) ? "0" + this.menit : this.menit;
                this.detik = (this.detik < 10) ? "0" + this.detik : this.detik;

                this.hariAngka = 'Jam: ' + this.jam + ':' + this.menit + ':' + this.detik; // 0 (Minggu) - 6 (Sabtu) [10]
                //this.durasi = this.jamdurasi + ':' + this.menitdurasi + ':' + this.detikdurasi; // 0 (Minggu) - 6 (Sabtu) [10]
                var tanggal = now.getDate(); // 1 - 31 [2]
                var bulan = now.getMonth(); // 0 - 11 [2]
                var tahun = now.getFullYear(); // 4 digit tahun [2]

                // Array nama hari dan bulan (opsional, untuk hasil dalam Bahasa Indonesia)
                var namaHari = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
                var namaBulan = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

                // Format: "Selasa, 3 Februari 2026"
                this.hasil = namaHari[now.getDay()] + ", " + tanggal + " " + namaBulan[bulan] + " " + tahun;

            }, 1000);
        },
        async ambilmaster() {
            this.halamanloading = true;

            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistemaksi"),
                },
            });
            var random = Math.random();
            await mainAPI5.get("androidAbsensi-GetDataKotaTujuan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.response;
                    //alert(this.datapesan);
                    if (this.datapesan == 'success') {
                        this.datastatus = [];
                        this.status = [];
                        this.datastatus = Response.data.content.data;
                        this.datastatus.forEach((item) => {
                            this.status.push({
                                label: item.nama,
                                code: this.datastatus.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.status.unshift({
                            label: 'Pilih Lokasi',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            })
        },
        onstatusChange(a) {
            try {
                this.selectedstatus = this.status[a].tag;
            }
            catch (err) {
                return;
            }
        },
        keluar() {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Keluar Aplikasi?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Keluar"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.ClearlocalStorageAksi();
                }
            });

            return false;
        },
    },
    mounted() {
        this.ambilmaster();
        this.LihatWaktu();
        var bulan = new Date().getMonth() + 1;
        bulan = (bulan < 10) ? "0" + bulan : bulan;
        this.dari_tanggal = new Date().getFullYear() + '-' + bulan + '-' + new Date().getDate();
        this.sampai_tanggal = new Date().getFullYear() + '-' + bulan + '-' + new Date().getDate();
        this.halamanloading = false;
    }
}
</script>
<style></style>